// Android back button, inside the Capacitor app only.
//
// Capacitor's default closes the app on back, from any screen: backing out of
// hero select dropped the player on the home screen. Instead back walks the
// router history, the same thing the browser's back button does on the web
// build, and only leaves the app from the first screen of the session.
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { router } from './router';

export function installNativeBack(): void {
  if (!Capacitor.isNativePlatform()) return;
  App.addListener('backButton', () => {
    // React Router keeps its own position in history.state.idx; 0 is the
    // entry the app launched on.
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) router.navigate(-1);
    else App.exitApp();
  });
}
